import Splide from '@splidejs/splide';

let levelUpSlider = document.getElementsByClassName('level-up-slider');

document.addEventListener('DOMContentLoaded', function () {
    for (let i = 0; i < levelUpSlider.length; i++) {
        let splide = new Splide(levelUpSlider[i], {
            type: 'slide',
            perPage: 3,
            perMove: 1,
            rewind: true,
            pagination: false,
            arrows: false,
            width: '100%',
            gap: '24px',
            autoHeight: true,
            breakpoints: {
                1023: {
                    perPage: 2,
                },
                768: {
                    perPage: 1,
                },
            }
        });

        let bar = splide.root.querySelector('.splide-progress-bar');

        splide.on('mounted move', function () {
            let end = splide.Components.Controller.getEnd() + 1;
            bar.style.width = String(100 * (splide.index + 1) / end) + '%';
        });

        splide.mount();
    }
});
